import { Routes, Route } from 'react-router-dom';
import { PortfolioLayout } from './PortfolioLayout';
import { AdminRouter } from './admin/AdminRouter';

function App() {
  return (
    <Routes>
      {/* Routes Admin */}
      <Route path="/admin/*" element={<AdminRouter />} />
      
      {/* Routes Portfolio (tout le reste) */}
      <Route path="/*" element={<PortfolioLayout />} />
    </Routes>
  );
}

export default App;
